import { version } from "../../package.json";

//export const API_URL = 'http://localhost:3000/';
//export const API_URL = 'http://Avepmdev2025-env-1.eba-ww3xnmvu.us-east-2.elasticbeanstalk.com/';

//export const API_URL = 'https://Avepmdev2025-env-1.eba-ww3xnmvu.us-east-2.elasticbeanstalk.com/';
//export const API_URL = 'https://api-dev.avepm.com/';

//export const API_URL = 'https://avepm2025-env-1.eba-mqvqu5yz.us-east-2.elasticbeanstalk.com/';

export const API_URL = 'https://api-beta.avepm.com/';


//export const BUCKET_URL = "https://us-east-2.console.aws.amazon.com/s3/buckets/uploaddev2025/";
//export const BUCKET_URL = "https://us-east-2.console.aws.amazon.com/s3/buckets/uploadbeta2025/";
export const BUCKET_URL = "https://uploadbeta2025.s3.us-east-2.amazonaws.com/";
//export const BUCKET_URL = "https://s3.us-east-2.amazonaws.com/uploadbeta/";
//export const BUCKET_URL = "https://s3.us-east-2.amazonaws.com/uploadbeta2025/";

export const VERSION = version;

export const MAIN = {
    API: {
        LOGIN: API_URL + 'sessions/login',
        LOGOUT: API_URL + 'sessions/logout',
        TOKEN: API_URL + 'token',
        VERSION: API_URL + 'version',
        LIST_USERS: API_URL + 'users/list',
        LIST_SCHOOLS: API_URL + 'users/list-schools',
        LIST_ADMIN_SCHOOLS: API_URL + 'users/list-admin-schools',
        CREATE_SCHOOL: API_URL + 'users/create-school',
        CREATE_USERS: API_URL + 'users/create',
        UPDATE_USERS: API_URL + 'users/update',
        DELETE_PARENT: API_URL + 'teacher/students/delete-parent',
        RESET_PASSWORD: API_URL + 'users/password-reset',
        CHANGE_PASSWORD: API_URL + 'users/newpassword',
        RESET_USERNAME: API_URL + 'users/username-request',
        TEACHER_CONSENT: API_URL + 'users/teacher-consent',
        REQUEST_ACCOUNT: API_URL + 'account-request',
        REQUEST_HELP: API_URL + 'help',
        REPORT_BUG: API_URL + 'report-bug',
        GET_CLASS_LIST: API_URL + 'teacher/classes/list',
        GET_TEACHER_CLASS_LIST: API_URL + 'teacher/classes/list-teacher-class',
        ADD_NEW_CLASS: API_URL + 'teacher/classes/create',
        UPDATE_CLASS: API_URL + 'teacher/classes/update',
        DELETE_CLASS: API_URL + 'teacher/classes/delete',
        LIST_EXTERNAL_TEACHER: API_URL + 'teacher/classes/external-list',
        LIST_STUDENTS: API_URL + 'teacher/students/list',
        ADD_NEW_STUDENT: API_URL + 'teacher/students/create',
        UPDATE_STUDENT: API_URL + 'teacher/students/update',
        TRANSFER_STUDENT: API_URL + 'teacher/students/transfer',
        TRANSFER_MULTIPLE_STUDENT: API_URL + 'teacher/students/transfer-multiple',
        DELETE_STUDENT: API_URL + 'teacher/students/delete',
        STUDENT_NOTIFICATIONS: API_URL + 'teacher/students/notifications',
        LIST_TEACHERS: API_URL + 'admin/teachers/list',
        LIST_TEACHERS_IN_SCHOOL: API_URL + 'admin/teachers/list-teachers-in-school',
        CREATE_TEACHER: API_URL + 'admin/teachers/create',
        UPDATE_TEACHER: API_URL + 'admin/teachers/update',
        DELETE_TEACHER: API_URL + 'admin/teachers/delete',
        LIST_SCHOOLADMINS: API_URL + 'admin/schooladmins/list',
        CREATE_SCHOOLADMIN: API_URL + 'admin/schooladmins/create',
        UPDATE_SCHOOLADMIN: API_URL + 'admin/schooladmins/update',
        DELETE_SCHOOLADMIN: API_URL + 'admin/schooladmins/delete',
        GET_STUDENT_BEST_SCORE: API_URL + 'student/bestscores/view',
        CHECK_STUDENT_DATA: API_URL + 'teacher/students/checkStudentData',
        GET_SURVEY_AMOUNT: API_URL + 'teacher/students/getSurveyAmount',
        CHECK_SURVEY_HOMEPAGE: API_URL + 'teacher/students/get-survey-homepage',
        CHECK_TEACHER_LOGIN: API_URL + 'teacher/survey/check-homepage',
        CHECK_TEACHER_RESOURCES: API_URL + 'teacher/survey/check-resources',
        CHECK_TEACHER_DATA_CHART: API_URL + 'teacher/survey/check-data-chart',
        CHECK_TEACHER_GRADING: API_URL + 'teacher/survey/check-grading',

        GET_MAZE_CONTENT: API_URL + 'apps/maze/mazecontent',
        GET_MAZE_SCORE_COUNT: API_URL + 'apps/maze/countscores',
        GET_MAZE_DISTRACTORS: API_URL + 'apps/maze/distractors',
        LIST_RANDOM_MAZE: API_URL + 'apps/maze/mazerandom',
        LIST_MAZE_SCORE_DATA: API_URL + 'apps/maze/score-data',
        UPDATE_MAZE_SCORE: API_URL + 'apps/maze/mazebestscore',
        UPDATE_MAZE_SCORE_NOTE: API_URL + 'apps/maze/score-note',
        POST_MAZE_SESSION: API_URL + 'apps/maze/maze-session',
        CREATE_MAZE_CONTENT: API_URL + 'apps/maze/create',
        GET_SLASH_CONTENT: API_URL + 'apps/slash/slashcontent',
        GET_SLASH_SCORE_COUNT: API_URL + 'apps/slash/countscores',
        LIST_RANDOM_SLASH: API_URL + 'apps/slash/slashrandom',
        LIST_SLASH_SCORE_DATA: API_URL + 'apps/slash/score-data',
        UPDATE_SLASH_SCORE: API_URL + 'apps/slash/slashbestscore',
        UPDATE_SLASH_SCORE_NOTE: API_URL + 'apps/slash/score-note',
        POST_SLASH_SESSION: API_URL + 'apps/slash/slash-session',

        ADD_WORDMARK_SESSION: API_URL + 'apps/wordmark/wordmark-session',
        LIST_WORDMARK_SCORE: API_URL + 'apps/wordmark/score-list',
        UPDATE_WORDMARK_GRADE: API_URL + 'apps/wordmark/wordmark-grade',
        LIST_RANDOM_WORDMARK: API_URL + 'apps/wordmark/wordmarkrandom',
        GET_WORDMARK_SCORE_DATA: API_URL + 'apps/wordmark/score-data',
        UPDATE_WORDMARK_SCORE_NOTE: API_URL + 'apps/wordmark/score-note',
        POST_WORDMARK_SESSION: API_URL + 'apps/wordmark/wordmark-session',
        DELETE_WORDMARK_SCORE: API_URL + 'apps/wordmark/delete',
        GET_WORDMARK_SESSION: API_URL + 'apps/wordmark/wordmark-session',

        ADD_WORDMARK2_SESSION: API_URL + 'apps/wordmark2/wordmark-session',
        LIST_WORDMARK2_SCORE: API_URL + 'apps/wordmark2/score-list',
        UPDATE_WORDMARK2_GRADE: API_URL + 'apps/wordmark2/wordmark-grade',
        LIST_RANDOM1_WORDMARK2: API_URL + 'apps/wordmark2/wordmark2random1',
        LIST_RANDOM2_WORDMARK2: API_URL + 'apps/wordmark2/wordmark2random2',
        GET_WORDMARK2_SCORE_DATA: API_URL + 'apps/wordmark2/score-data',
        UPDATE_WORDMARK2_SCORE_NOTE: API_URL + 'apps/wordmark2/score-note',
        POST_WORDMARK2_SESSION: API_URL + 'apps/wordmark2/wordmark-session',
        DELETE_WORDMARK2_SCORE: API_URL + 'apps/wordmark2/delete',
        GET_WORDMARK2_SESSION: API_URL + 'apps/wordmark2/wordmark-session',

        UPLOAD_KIDSPEAK_FILE: API_URL + 'apps/kidspeak/upload',
        DELETE_KIDSPEAK_FILE: API_URL + 'apps/kidspeak/delete-audio',
        ADD_KIDSPEAK_SESSION: API_URL + 'apps/kidspeak/ks-session',
        GET_KIDSPEAK_SESSION: API_URL + 'apps/kidspeak/ks-session',
        GET_KIDSPEAK_SCORE_LIST: API_URL + 'apps/kidspeak/score-list',
        UPDATE_KIDSPEAK_GRADE: API_URL + 'apps/kidspeak/ks-grade',
        GET_KIDSPEAK_RANDOM: API_URL + 'apps/kidspeak/ksrandom',
        GET_KIDSPEAK_DATA: API_URL + 'apps/kidspeak/score-data',
        UPDATE_KIDSPEAK_SCORE_NOTE: API_URL + 'apps/kidspeak/score-note',
        DELETE_KIDSPEAK_SCORE: API_URL + 'apps/kidspeak/delete',
        UPDATE_KIDSPEAK_BEST_SCORE:API_URL + "apps/kidspeak/ksbestscore",
        List_MAZE_PASSAGE: API_URL + "apps/maze/list-passage",
        ADD_MAZE_PASSAGE: API_URL + "apps/maze/add-passage",
        DELETE_MAZE_PASSAGE: API_URL + "apps/maze/delete-passage",
        UPDATE_MAZE_PASSAGE: API_URL + "apps/maze/update-passage",
        ACTIVEATE_MAZE_PASSAGE: API_URL + "apps/maze/activate-passage",

        List_KIDSPEAK_PASSAGE: API_URL + "apps/kidspeak/list-passage",
        List_KIDSPEAK_PASSAGE_BY_UID: API_URL + "apps/kidspeak/list-passage-by-uid",
        ADD_KIDSPEAK_PASSAGE: API_URL + "apps/kidspeak/add-passage",
        DELETE_KIDSPEAK_PASSAGE: API_URL + "apps/kidspeak/delete-passage",
        UPDATE_KIDSPEAK_PASSAGE: API_URL + "apps/kidspeak/update-passage",
        ACTIVEATE_KIDSPEAK_PASSAGE: API_URL + "apps/kidspeak/activate-passage",

        UPLOAD_PICTURENAMING_FILE: API_URL + 'apps/picturenaming/upload',
        DELETE_PICTURENAMING_FILE: API_URL + 'apps/picturenaming/delete-video',
        ADD_PICTURENAMING_SESSION: API_URL + 'apps/picturenaming/pn-session',
        GET_PICTURENAMING_SESSION: API_URL + 'apps/picturenaming/pn-session',
        GET_PICTURENAMING_SCORE_LIST: API_URL + 'apps/picturenaming/score-list',
        UPDATE_PICTURENAMING_GRADE: API_URL + 'apps/picturenaming/pn-grade',
        PICTURENAMING_MANUAL_GRADE: API_URL + 'apps/picturenaming/pn-manual-grade',
        GET_PICTURENAMING_MANUAL_SCORE: API_URL + 'apps/picturenaming/pn-manual-score',
        GET_PICTURENAMING_RANDOM: API_URL + 'apps/picturenaming/pnrandom',
        GET_PICTURENAMING_DATA: API_URL + 'apps/picturenaming/score-data',
        UPDATE_PICTURENAMING_SCORE_NOTE: API_URL + 'apps/picturenaming/score-note',
        ADD_PICTURENAMING_1ON1: API_URL + 'apps/picturenaming/pn-1On1',
        DELETE_PICTURENAMING_SCORE: API_URL + 'apps/picturenaming/delete',
        START_PICTURENAMING_WEBSOCKET: API_URL.replace("http","ws") + 'apps/picturenaming/session-join',
        UPDATE_PICTURENAMING_BEST_SCORE:API_URL + "apps/picturenaming/pnbestscore",

        UPLOAD_COPYRIGHT_FILE: API_URL + 'apps/copyright/upload',
        DELETE_COPYRIGHT_FILE: API_URL + 'apps/copyright/delete-audio',
        ADD_COPYRIGHT_SESSION: API_URL + 'apps/copyright/cr-session',
        GET_COPYRIGHT_SESSION: API_URL + 'apps/copyright/cr-session',
        GET_COPYRIGHT_SCORE_LIST: API_URL + 'apps/copyright/score-list',
        UPDATE_COPYRIGHT_GRADE: API_URL + 'apps/copyright/cr-grade',
        GET_COPYRIGHT_RANDOM: API_URL + 'apps/copyright/crrandom',
        GET_COPYRIGHT_DATA: API_URL + 'apps/copyright/score-data',
        UPDATE_COPYRIGHT_SCORE_NOTE: API_URL + 'apps/copyright/score-note',
        DELETE_COPYRIGHT_SCORE: API_URL + 'apps/copyright/delete',
        UPDATE_COPYRIGHT_BEST_SCORE:API_URL + "apps/copyright/crbestscore",


        UPLOAD_WORDSIGNSAY_FILE: API_URL + 'apps/wordsignsay/upload',
        DELETE_WORDSIGNSAY_FILE: API_URL + 'apps/wordsignsay/delete-video',
        ADD_WORDSIGNSAY_SESSION: API_URL + 'apps/wordsignsay/wss-session',
        GET_WORDSIGNSAY_SESSION: API_URL + 'apps/wordsignsay/wss-session',
        GET_WORDSIGNSAY_SCORE_LIST: API_URL + 'apps/wordsignsay/score-list',
        UPDATE_WORDSIGNSAY_GRADE: API_URL + 'apps/wordsignsay/wss-grade',
        GET_WORDSIGNSAY_RANDOM: API_URL + 'apps/wordsignsay/wssrandom',
        GET_WORDSIGNSAY_DATA: API_URL + 'apps/wordsignsay/score-data',
        UPDATE_WORDSIGNSAY_SCORE_NOTE: API_URL + 'apps/wordsignsay/score-note',
        UPDATE_WORDSIGNSAY_BEST_SCORE:API_URL + "apps/wordsignsay/wssbestscore",
        DELETE_WORDSIGNSAY_SCORE: API_URL + 'apps/wordsignsay/delete',

        UPLOAD_KIDSIGN_FILE: API_URL + 'apps/kidsign/upload',
        DELETE_KIDSIGN_FILE: API_URL + 'apps/kidsign/delete-audio',
        ADD_KIDSIGN_SESSION: API_URL + 'apps/kidsign/kss-session',
        GET_KIDSIGN_SESSION: API_URL + 'apps/kidsign/kss-session',
        GET_KIDSIGN_SCORE_LIST: API_URL + 'apps/kidsign/score-list',
        UPDATE_KIDSIGN_GRADE: API_URL + 'apps/kidsign/kss-grade',
        GET_KIDSIGN_RANDOM: API_URL + 'apps/kidsign/kssrandom',
        GET_KIDSIGN_DATA: API_URL + 'apps/kidsign/score-data',
        UPDATE_KIDSIGN_SCORE_NOTE: API_URL + 'apps/kidsign/score-note',
        DELETE_KIDSIGN_SCORE: API_URL + 'apps/kidsign/delete',
        UPDATE_KIDSIGN_BEST_SCORE:API_URL + "apps/kidsign/kssbestscore",

        GET_USER_BESTSCORES: API_URL + "student/bestscores/grade-view",
        GET_STUDENT_APPS_STATUS: API_URL + "student/apps/status",
        GET_UNGRADED_TASKS: API_URL + "student/apps/ungraded-tasks",
        GET_PARENT_STUDENTS: API_URL + "student/apps/getParentStudents",

        ADD_ANALYTICS: API_URL + "analytics/add",
        ADD_ANALYTICS_NONUSER: API_URL + "analytics/add-nonuser"

    }
};




// WEBPACK FOOTER //
// ./src/Shared/Consts.js